// hooks
import { useEffect, useCallback, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useHttp from "hooks/use-http";
import { useNavigate } from "react-router-dom";

// material styles
import {
  Grid,
  Button,
  TextField,
  Checkbox,
  FormControlLabel,
  FormGroup,
} from "@mui/material";

// material icons
import CheckIcon from "@mui/icons-material/Check";

// request methods
import {
  addWorkSampleRequest,
  getWorkSampleCategoryRequest,
} from "api/requests/work_sample";

// components
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import ProgressBarCM from "components/shared/ProgressBar";
import Upload from "components/shared/Upload";

import ReactHookFormSelect from "components/shared/ReactHookFormSelect";

// helper
import Toast from "helper/toast";

// form validate
import { workSampleSchema, validateImg } from "validations";

// styled component
import {
  StyledStack,
  StyledTitle,
  ButtonContainer,
  StyledMenuItem,
} from "./addWorkSample.style";

// editor library
import Editor, { buttonList } from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import BackButton from "components/shared/BackButton";

export default function AddWorkSample() {
  const {
    request,
    loading,
    setLoading,
    isUploading,
    uploadProgress,
    setUploadProgress,
  } = useHttp(false);

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(workSampleSchema),
  });

  // upload image state
  const [workSampleImage, setWorkSampleImage] = useState({
    url: null,
    isChanged: false,
  });

  // // select option state
  // const [categoryList, setCategoryList] = useState([]);
  // const [selectedCategory, setSelectedCategory] = useState(null);

  // editor value
  const [text, setText] = useState("");

  // text editor value handler method
  const handleChangeText = (text) => setText(text);

  // add workSample
  const onSubmit = async (data) => {
    if (!text) return Toast({ type: "empty", title: "فیلد توضیحات " });
    if (!workSampleImage.url)
      return Toast({ type: "empty", title: "فیلد عکس " });
    const res = await request({
      url: () =>
        addWorkSampleRequest(
          {
            ...data,
            description: text,
            // category_id: selectedCategory,
            image: workSampleImage,
          },
          (progress) => setUploadProgress(progress)
        ),
      isFile: true,
    });
    if (res) {
      Toast({ type: "success", title: "افزودن نمونه کار" });
      navigate("/work_samples");
    }
  };

  // uploaded image handler method
  const handleChangeWorkSamplesImage = (val) => {
    validateImg(val);
    setWorkSampleImage({ url: val, isChanged: true });
  };

  // // get category
  // const getWorkSampleCategoryData = useCallback(async () => {
  //   const res = await request({
  //     url: getWorkSampleCategoryRequest,
  //     values: {
  //       skip: 0,
  //       limit: 100,
  //       search: null,
  //     },
  //     isMulty: true,
  //   });
  //   setLoading(false);
  //   if (res) {
  //     let transformedData = res.data?.data.map((items) => ({
  //       id: items.id,
  //       title: items.title,
  //     }));
  //     setCategoryList(transformedData);
  //   }
  // }, [request]);

  // useEffect(() => {
  //   getWorkSampleCategoryData();
  // }, [getWorkSampleCategoryData]);

  return (
    <DrawerCM title="افزودن نمونه کار">
      {isUploading ? (
        <ProgressBarCM value={uploadProgress} />
      ) : loading ? (
        <LoadingCM />
      ) : (
        <Grid container>
          <Grid item mt={3} xs={12}>
            <BackButton Route="/work_samples" />
          </Grid>
          <StyledStack>
            <StyledTitle>افزودن نمونه کار</StyledTitle>
            <Grid container>
              <Grid item md={6} xs={12} flexDirection="column">
                <Grid item xs={12} p={1.2}>
                  <TextField
                    label="عنوان"
                    variant="outlined"
                    fullWidth
                    id="title"
                    {...register("title")}
                    error={Boolean(errors.title)}
                    helperText={errors.title?.message}
                  />
                </Grid>
                <Grid item xs={12} p={1.2}>
                  <TextField
                    label="لینک"
                    variant="outlined"
                    fullWidth
                    id="link"
                    {...register("link")}
                    error={Boolean(errors.link)}
                    helperText={errors.link?.message}
                  />
                </Grid>
                {/* <Grid item xs={12} p={1.2}>
                  <ReactHookFormSelect
                    label="سردسته"
                    control={control}
                    title="سردسته"
                    id="category"
                    {...register("category")}
                    error={Boolean(errors.category)}
                    helperText={errors.category?.message}
                    onChange={(value) => setSelectedCategory(value)}
                  >
                    {categoryList?.map((item, index) => (
                      <StyledMenuItem key={index} value={item.id}>
                        {item.title}
                      </StyledMenuItem>
                    ))}
                  </ReactHookFormSelect>
                </Grid> */}
              </Grid>
              <Grid item md={6} xs={12} p={1.2}>
                {workSampleImage.url ? (
                  <Upload
                    isWeb={workSampleImage.isWeb}
                    isLocal={!workSampleImage.isWeb}
                    file={workSampleImage.url}
                    refillable
                    type="add-work-sample"
                    onChange={handleChangeWorkSamplesImage}
                    width={"100%"}
                    height={"100%"}
                    objectFit="contain"
                  />
                ) : (
                  <Upload
                    isLocal={workSampleImage.isChanged}
                    file={workSampleImage.url}
                    refillable
                    type="add-work-sample"
                    onChange={handleChangeWorkSamplesImage}
                    width={"100%"}
                    height={"100%"}
                    objectFit="contain"
                  />
                )}
              </Grid>
              <Grid item md={6} xs={12} p={1.2}>
                <TextField
                  label=" متن جایگزین"
                  variant="outlined"
                  fullWidth
                  id="alt"
                  {...register("alt")}
                  error={Boolean(errors.alt)}
                  helperText={errors.alt?.message}
                />
              </Grid>
              <Grid item md={6} xs={12} p={1.2}>
                <TextField
                  label="کلمه کلیدی"
                  variant="outlined"
                  fullWidth
                  id="keyword"
                  {...register("keyword")}
                  error={Boolean(errors.keyword)}
                  helperText={errors.keyword?.message}
                />
              </Grid>
              <Grid item xs={12} p={1.2}>
                <TextField
                  label="فراتوضیحات"
                  variant="outlined"
                  fullWidth
                  id="meta_description"
                  {...register("meta_description")}
                  error={Boolean(errors.meta_description)}
                  helperText={errors.meta_description?.message}
                />
              </Grid>
              <Grid item xs={12} p={1.2}>
                <Editor
                  enableToolbar={true}
                  onChange={handleChangeText}
                  defaultValue={text}
                  setDefaultStyle="font-family: IranSans; height: 40vh;"
                  setOptions={{
                    buttonList: buttonList.complex,
                    font: [
                      "IranSans",
                      "IranSansBold",
                      "Arial",
                      "Impact",
                      "Tahoma",
                    ],
                  }}
                />
              </Grid>

              <ButtonContainer>
                <Button
                  startIcon={<CheckIcon />}
                  variant="contained"
                  sx={{ mt: 1 }}
                  onClick={handleSubmit(onSubmit)}
                >
                  ذخیره
                </Button>
              </ButtonContainer>
            </Grid>
          </StyledStack>
        </Grid>
      )}
    </DrawerCM>
  );
}
